
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/heritagetradeprizedraw/thank-you",
      function () {
        return require("private-next-pages/en/heritagetradeprizedraw/thank-you.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/heritagetradeprizedraw/thank-you"])
      });
    }
  